import React, { useRef } from "react";
import "./ReviewSlider.css";

const reviewsData = [
  {
    id: 1,
    name: "Srividya Malkapuram",
    rating: 5,
    content:
      "Very promising and innovative, and much required in these times. This is applying AI to real world business requirements in a useful way.",
  },
  {
    id: 2,
    name: "Anjani Kumar",
    rating: 5,
    content:
      "AI chatbot and agentic AI is very useful and cost effective tool, easy to use and integrate for MSMEs!",
  },
  {
    id: 3,
    name: "Shweta Agrawal",
    rating: 5,
    content:
      "An excellent 24/7 multilingual voice support service that ensures seamless customer interactions across regions. The response quality, language fluency, and reliability are very impressive.",
  },
  {
    id: 4,
    name: "Anil Goud",
    rating: 5,
    content:
      "An economical solution for many HR related requirements",
  },
];

const ReviewSlider = () => {
  const sliderRef = useRef(null);

  const scroll = (direction) => {
    const width = sliderRef.current.offsetWidth;
    sliderRef.current.scrollBy({
      left: direction === "left" ? -width : width,
      behavior: "smooth",
    });
  };

  return (
    <div className="review-slider-outer">
      <button className="slider-btn prev" onClick={() => scroll("left")}>
        &#10094;
      </button>

      <div className="review-container" ref={sliderRef}>
        {reviewsData.map((review) => (
          <div className="review-card" key={review.id}>
            <h4 className="review-name">{review.name}</h4>

            <div className="review-stars">
              {[...Array(review.rating)].map((_, i) => (
                <span key={i}>★</span>
              ))}
            </div>

            <p className="review-text">
              {review.content}
            </p>
          </div>
        ))}
      </div>

      <button className="slider-btn next" onClick={() => scroll("right")}>
        &#10095;
      </button>
    </div>
  );
};

export default ReviewSlider;
